<div class="flex flex-col gap-2">
  <label class="form-label">{{label}}</label>
  <div class="relative">
    <select
      [formControl]="control"
      [ngClass]="{ 'form-input--error': isFieldInvalid() }"
      class="w-full border border-age-brown rounded-xl px-4 py-3 text-gray-700 bg-white focus:outline-none focus:border-age-green appearance-none cursor-pointer form-input"
    >
      <option value="" disabled class="text-gray-400">
        Sélectionnez votre option
      </option>
      @for (option of options; track option.value){
      <option [value]="option.value">{{option.label}}</option>
      }
    </select>
    <!-- <lib-expand></lib-expand> -->
    @if (isFieldInvalid()) {
    <span class="form-span--error">Ce champ est requis</span>
    }
  </div>
</div>
